module.exports = __webpack_public_path__ + "img/ModernCosmetics.091e83ff.png";